import React from 'react'

export default function Aka() {
  return (
    <div>
      <h1>Akashik Records</h1>
    </div>
  )
}
